<script>
import ClickOutside from "vue-click-outside";
export default {
  directives: {
    ClickOutside
  },
  props: {
    min: {
      type: Number,
      default: 7
    },
    max: {
      type: Number,
      default: 22
    },
    value: {
      type: Number,
      required: false
    }
  },
  methods: {
    hidePicker() {
      if (this.show) this.show = false;
    },
    increase() {
      let val = this.value < this.max ? this.value + 1 : this.value;
      this.$emit("changed", val);
    },
    decrease() {
      let val = this.value > this.min ? this.value - 1 : this.value;
      this.$emit("changed", val);
    }
  },
  filters: {
    format(val) {
      if (val < 10) val = "0" + val;
      return val + ":00";
    }
  }
};
</script>

<template>
  <div class="hour-picker">
    <div @click="decrease">-</div>
    <span>{{value | format}}</span>
    <div @click="increase">+</div>
  </div>
</template>

<style lang="scss" scoped>
.hour-picker {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  @media (max-width: 480px) {
    margin-bottom: 14px;
  }
  span {
    color: $purple;
    background-color: rgba($purple, 0.05);
    border: 1px solid #ddd;
    border-left: none;
    border-right: none;
    padding: 10px;
    font-size: 16px;
  }
  > div {
    color: #af006b;
    border: 1px solid #ddd;
    padding: 10px 15px;
    user-select: none;
    cursor: pointer;
    font-weight: 400;
    font-size: 16px;
    &:first-child {
      border-radius: 4px 0 0 4px;
    }
    &:last-child {
      border-radius: 0 4px 4px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/HourPicker.vue